import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  as?: "h2" | "h3";
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  as = "h2",
}: SectionHeadingProps) {
  const Heading = as;
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="min-w-0">
        <div className="flex items-center gap-2.5">
          <span className="w-1 h-5 rounded-full bg-accent-500" />
          <Heading className="font-heading text-xl md:text-2xl font-bold text-foreground-950 truncate">
            {title}
          </Heading>
        </div>
        {subtitle && (
          <p className="mt-2 text-sm text-foreground-600 leading-6">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}